/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Permissions } from '@app/core/guard/Permissions';
import { VaultBaseComponent } from '@app/shared/components/base/vault-base.component';
import { TableAction, TableActions } from '@app/shared/components/table/table.component';
import { Tenant } from '@interfaces/a-organizar/tenant';
import { User } from '@interfaces/a-organizar/user';
import { Pagination } from '@interfaces/common/pagination';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogService } from '@services/helpers/dialog.service';
import { ToastHelperService } from '@services/helpers/toast-helper.service';
import { OnboardingService } from '@services/http/onboarding.service';
import { UserService } from '@services/http/user.service';
import { UserDataAction } from '@src/app/shared/components/user-data-h/user-data-h.component';
import { MenuItem } from 'primeng/api';
import { PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'app-tenant-list-content',
  templateUrl: './tenant-list-content.component.html',
  styleUrls: ['./tenant-list-content.component.scss'],
  standalone: false,
})
export class TenantListContentComponent extends VaultBaseComponent implements OnInit {
  /** Primeira listagem em andamento: mantém a tabela visível para o esqueleto aparecer. */
  @Input() loading = false;
  @Input() groupList: Tenant[] = [];
  @Input() pagination: Pagination = {
    total: 0,
    currentPage: 0,
    pages: 0,
    itemsPerPage: 0,
  };
  @Output() sendTablePagination: EventEmitter<PaginatorState> = new EventEmitter<PaginatorState>();
  @Output() sendTableAction: EventEmitter<TableActions<Tenant>> = new EventEmitter<
    TableActions<Tenant>
  >();

  tenantPermissions = Permissions.Tenant;
  headers: string[] = [];
  columns: string[] = [];
  tableOptions: MenuItem[] = [];
  users: User[] = [];
  selectedTenant: Tenant | null = null;
  selectedUser: User | null = null;

  constructor(
    translateService: TranslateService,
    private router: Router,
    private dialogService: ConfirmDialogService,
    private onboardingService: OnboardingService,
    private userService: UserService,
    private toast: ToastHelperService
  ) {
    super(translateService);
  }

  ngOnInit(): void {
    this.tableOptions = [
      {
        label: this.t(this.tk.General.Update),
        action: 'edit',
      },
      {
        label: this.t(this.tk.General.Delete),
        action: 'delete',
      },
      {
        label: this.t(this.tk.Onboarding.SendOnboarding),
        action: 'send-onboarding',
      },
    ];
    this.headers = [this.t(this.tk.Management.Name), this.t(this.tk.Management.Description), ''];
    this.columns = ['name', 'description', 'options'];
  }

  handleTableAction(tableAction: TableAction<Tenant>) {
    switch (tableAction.action) {
      case 'edit':
        this.router.navigate(['dashboard/tenant/register', tableAction.item.id]);
        break;
      case 'delete':
        this.handleDeleteAction(tableAction.item);
        break;
      case 'send-onboarding':
        this.handleSendingOnboarding(tableAction.item);
        break;
      case 'add-user':
        this.router.navigate([`dashboard/user/register`]);
        break;
    }
  }

  handleTablePagination(pagination: PaginatorState) {
    this.sendTablePagination.emit(pagination);
  }

  addTenant(): void {
    this.router.navigate(['dashboard/tenant/register']);
  }

  handleDeleteAction(item: Tenant) {
    this.dialogService
      .confirm(
        this.t(this.tk.Management.TenantTitleDeleteConfirmation),
        this.t(this.tk.Management.TenantDescriptionDeleteConfirmation),
        this.t(this.tk.General.Yes),
        this.t(this.tk.General.No)
      )
      .then(response => {
        if (response) {
          this.sendTableAction.emit({
            action: 'delete',
            items: [item],
          });
        }
      })
      .catch(error => {
        console.error('Error: ', error);
      });
  }

  handleSendingOnboarding(tenant: Tenant) {
    this.selectedTenant = tenant;

    this.userService.getUsersList({ PageSize: 100 }, '', { tenantId: tenant.id }).subscribe({
      next: response => {
        this.users = response?.data || [];
        this.dialogService.confirm(
          '',
          this.t(this.tk.Onboarding.ChooseUserToSendOnboardingLink),
          '',
          '',
          '',
          'select-user-to-onboarding',
          false,
          false
        );
      },
      error: error => {
        console.error('getUsersList error: ', error);
      },
    });
  }

  handleSendAction(action: UserDataAction, user: User): void {
    this.selectedUser = user;
    this.onboardingService
      .postTenantSendMainEmailOnboarding(this.selectedTenant?.id as string, user.id)
      .subscribe({
        next: () => {
          this.dialogService.close();

          this.dialogService.confirm(
            this.t(this.tk.Onboarding.invitationToUserByCompanySuccess, {
              email: user.email,
            }),
            this.t(this.tk.Onboarding.registrationCompleted),
            this.t(this.tk.General.Ok),
            '',
            '',
            'user-to-onboarding-success',
            false,
            true
          );
        },
        error: error => {
          console.error('postTenantSendMainEmailOnboarding error: ', error);
          this.toast.showToastError(
            this.t(this.tk.Onboarding.ErrorSendingOnboardingLink),
            error?.errors?.length ? error.errors[0].message : this.t(this.tk.General.RequestError)
          );
        },
      });
  }

  get formatedGroupList(): Tenant[] {
    const formated = this.groupList.map((group: Tenant) => {
      return group;
    });
    return formated;
  }
}
